module.exports = __webpack_public_path__ + "img/eaglestarLogo.e46afb13.png";